angular.module('homebot.directives')

.directive('navDropdownToggle', ['NavDropdownService', function(NavDropdownService){
  return {
    restrict: 'A',
    controllerAs: 'navDropdownToggleCtrl',
    bindToController: {
    },
    scope: {},

    controller: function(){

    },

    link: function($scope, el, attrs, ctrl){
      $(el).on('click', () => {
        NavDropdownService.set(attrs.navDropdownToggle);

        if (attrs.class === "navigation-dropdown-trigger") {
          $('.navigation-tools').toggleClass('navigation-tools--active')
        }
      });
    }
  }
}]);
